import React, { useState, useEffect } from "react";

import { Table, Button, Spinner, Row } from "react-bootstrap";

import { search3cCultivations } from "../../../controllers/ControllerCultivation";

function TableSearchCultivation(props) {
  const {
    code3c_id,
    client_id,
    property_id,
    cultivation_id,
    inputSearch,
    handleCultivation,
    clearProperty,
    showSearchCultivationVarietiesModal,
  } = props;

  const [cultivationList, setCultivationList] = useState([]);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    async function get3cCultivations() {
      const response = await search3cCultivations(code3c_id);
      if (response) {
        setCultivationList(response);
        setPending(true);
      }
    }
    get3cCultivations();
    // eslint-disable-next-line
  }, [showSearchCultivationVarietiesModal, property_id]);

  return cultivationList.length === 0 && !pending ? (
    <Row>
      <Spinner className="mx-auto my-5 text-system" animation="border" />
    </Row>
  ) : (
    <Table striped bordered hover size="sm" className="rounded">
      {client_id !== "" && (
        <thead>
          <tr>
            <th width="100%" colSpan="3" className="align-middle text-center">
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => clearProperty()}
              >
                Voltar
              </Button>
            </th>
          </tr>
        </thead>
      )}
      <thead>
        <tr>
          <th width="2%">#</th>
          <th width="88%">Cultura</th>
          <th width="10%" className="text-center">
            Selecionar
          </th>
        </tr>
      </thead>
      <tbody>
        {cultivationList
          .sort(function (a, b) {
            var nameA = a.name.toLowerCase(),
              nameB = b.name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          })
          .filter(
            (item) =>
              item.id.indexOf(inputSearch) !== -1 ||
              item.name.toUpperCase().indexOf(inputSearch.toUpperCase()) !== -1,
          )
          .map((cultivation, index) => (
            <tr key={index}>
              <td width="2%" className="align-middle">
                <b>{index + 1}</b>
              </td>
              <td width="63%" className="align-middle">
                {cultivation.name}
              </td>
              <td width="10%" className="text-center align-middle">
                <Button
                  disabled={cultivation_id === cultivation.id ? true : false}
                  className="bg-system"
                  size="sm"
                  onClick={() =>
                    handleCultivation(cultivation.id, cultivation.name)
                  }
                >
                  Selecionar
                </Button>
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
}

export default TableSearchCultivation;
